import React, { useState } from 'react';

interface Props {
  title: string;
  url?: string;
}

const ProductShare: React.FC<Props> = ({ title, url }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url ?? (typeof window !== 'undefined' ? window.location.href : '');
  const encUrl = encodeURIComponent(shareUrl);
  const encTitle = encodeURIComponent(title);

  const copyLink = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  const nativeShare = () => {
    if ((navigator as any).share) {
      (navigator as any).share({ title, url: shareUrl }).catch(() => {});
    }
  };

  return (
    <div className="pd-share">
      <span className="pd-share__label">Sdílet:</span>
      <a
        className="pd-share__btn pd-share__btn--fb"
        href={`https://www.facebook.com/sharer/sharer.php?u=${encUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Sdílet na Facebooku"
        title="Facebook"
      >f</a>
      <a
        className="pd-share__btn pd-share__btn--x"
        href={`https://twitter.com/intent/tweet?url=${encUrl}&text=${encTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Sdílet na X (Twitter)"
        title="X / Twitter"
      >𝕏</a>
      <a
        className="pd-share__btn pd-share__btn--pinterest"
        href={`https://pinterest.com/pin/create/button/?url=${encUrl}&description=${encTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Uložit na Pinterest"
        title="Pinterest"
      >P</a>
      <a
        className="pd-share__btn pd-share__btn--email"
        href={`mailto:?subject=${encTitle}&body=${encUrl}`}
        aria-label="Sdílet e-mailem"
        title="E-mail"
      >@</a>
      <button
        className="pd-share__btn pd-share__btn--copy"
        onClick={copyLink}
        aria-label="Kopírovat odkaz"
        title={copied ? 'Zkopírováno!' : 'Kopírovat odkaz'}
      >{copied ? '✓' : '🔗'}</button>
      {typeof navigator !== 'undefined' && (navigator as any).share && (
        <button
          className="pd-share__btn pd-share__btn--native"
          onClick={nativeShare}
          aria-label="Sdílet…"
          title="Sdílet…"
        >…</button>
      )}
    </div>
  );
};

export default ProductShare;
